import {Component} from '@angular/core';
import {FormBuilder, Validators} from '@angular/forms';
import {ActivatedRoute} from '@angular/router';
import {confirmPasswordValidator} from '../../../core/services/user/validator/confirm-password.validator';
import {AuthenticationRestApiService} from '../services/http/authentication-rest-api.service';
import {MatSnackBar} from '@angular/material/snack-bar';
import {LoggerService} from '../../../core/services/logger/logger.service';
import {HttpUtils, Utils} from '@astek/utils';
import {TranslocoService} from '@jsverse/transloco';
import {RoutesEnum} from '../../../core/services/navigation/routes.enum';
import {HttpErrorResponse} from '@angular/common/http';
import {ApiResetPasswordKnownErrorsEnum} from '../services/http/api-reset-password-known-errors.enum';
import {NavigationService} from '../../../core/services/navigation/navigation.service';
import { differentPasswordValidator } from '../../../core/services/user/validator/different-password.validator';

@Component({
  selector: 'xp-expired-password',
  templateUrl: './expired-password.component.html',
  styleUrls: ['../authentication.common.scss', './expired-password.component.scss'],
})
export class ExpiredPasswordComponent {

  // At least 8 characters for users 16 for admins, including lowercase, uppercase and numeric
  // and special chars in: . , / ! @ # $ % ^ & * ( ) - _ { } [ ] : ;
  public readonly pwdRegexp: RegExp = /^.*(?=.{8,})(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[.,/!@#$%^&*()\-_{}[\]:;]).*$/;

  public readonly formGroup = this._formBuilder.group({
    actualPassword: ['', [Validators.required.bind(Validators), Validators.pattern(this.pwdRegexp).bind(Validators)]],
    password: ['', [Validators.required.bind(Validators), Validators.pattern(this.pwdRegexp).bind(Validators)]],
    confirm: ['', [Validators.required.bind(Validators), Validators.pattern(this.pwdRegexp).bind(Validators)]],
  }, {validators: [confirmPasswordValidator, differentPasswordValidator]});

  public showPassword: boolean = false;
  public showConfirm: boolean = false;

  public readonly token: string = '';

  private _isProcessing: boolean = false;
  private _errorKey: string = '';

  constructor(
    private readonly _authenticationRestApiService: AuthenticationRestApiService,
    private readonly _formBuilder: FormBuilder,
    private readonly _route: ActivatedRoute,
    private readonly _loggerService: LoggerService,
    private readonly _snackBar: MatSnackBar,
    private readonly _translocoService: TranslocoService,
    private readonly _navigationService: NavigationService,
  ) {
    if (Utils.isNullOrUndefined(this._route.snapshot.params['token'])) {
      this._loggerService.error('No token provided');
    }
    this.token = this._route.snapshot.params['token'] as string;
  }

  public get isProcessing(): boolean {
    return this._isProcessing;
  }

  public get errorKey(): string {
    return this._errorKey;
  }

  public requestPasswordExpired(): void {
    if (this.formGroup.invalid) {
      return;
    }
    this._isProcessing = true;
    this._authenticationRestApiService.requestPasswordExpired({
      token: this.token,
      password: this.formGroup.controls.actualPassword.value ?? '',
      newPassword: this.formGroup.controls.password.value ?? '',
    })
      .subscribe({
        next: async () => {
          this._snackBar.open(
            this._translocoService.translate('AUTHENTICATION.EXPIRED_PASSWORD.SUCCESS'),
            '',
            {duration: 7000},
          );
          await this._navigationService.navigateTo(RoutesEnum.AUTHENTICATION);
        },
        error: (error: HttpErrorResponse) => this.handleError(error),
      });
  }

  private handleError(error: HttpErrorResponse): void {
    this._isProcessing = false;
    if (HttpUtils.isSymfonyKnownError(error, ApiResetPasswordKnownErrorsEnum)) {
      this._errorKey = 'AUTHENTICATION.EXPIRED_PASSWORD.' + HttpUtils.getSymfonyKnownErrorDetailMessage(error);
      return;
    }
    this._errorKey = 'SHARED.ERRORS.UNKNOWN';
  }

}
